const MODULE = document.querySelectorAll('[data-module="header-single"]');

class HeaderSingle {
    constructor(component) {
        this.component = component;
        this.init();
    }

    init() {
        const url = window.location.href;
        const title = document.title;

        const whatsapp = this.component.querySelector('.share-whatsapp');
        if (whatsapp) whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;

        const linkedin = this.component.querySelector('.share-linkedin');
        if (linkedin) linkedin.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

        const x = this.component.querySelector('.share-x');
        if (x) x.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;

        const copy = this.component.querySelector('.share-copy');
        if (copy) {
            copy.addEventListener('click', () => {
                navigator.clipboard.writeText(url);
            });
        }
    }
}

(() => {
    MODULE.forEach((component) => new HeaderSingle(component));
})();

export default HeaderSingle;
